import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const CandidaturasModule = {
	state: {
		candidaturas : ''
	},
	getters: {  
        getCandidaturas : state => state.candidaturas
	},
	actions: {
        requestCandidaturas({commit}){
            return new Promise((resolve, reject) => {
				axios.get("/api/Alumno/dameCandidaturas").then( result => {
					commit('setCandidaturas', result.data.datos); 
					resolve(true);
				}).catch(error => {
					reject(false);
				});  
			});	
        },
	},
	mutations: {
        setCandidaturas(state, candidaturas){
            state.candidaturas = candidaturas;
        }
	}
}

export default CandidaturasModule;


// WEBPACK FOOTER //
// ./src/store/candidaturasModule.js